import React, { Suspense } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';

import Login from './containers/Auth/Login/Login';
import Logout from './containers/Auth/Logout/Logout';
import useGlobalStyles from './theme/global-classes';

const Sites = React.lazy(() => import('./containers/Sites/Sites'));
const CurrentLabor = React.lazy(() => import('./containers/CurrentLabor/CurrentLabor'));
const UnitAvailability = React.lazy(() => import('./containers/UnitAvailability/UnitAvailability'));
const CsiEvents = React.lazy(() => import('./containers/CsiEvents/CsiEvents'));
const ReportIssue = React.lazy(() => import('./containers/ReportIssue/ReportIssue'));

const Routes = ({ isAuthenticated }) => {
	useGlobalStyles();
	let routes = (
		<Switch>
			<Route path="/login" component={Login} />
			<Route exact path="/" component={Login} />
			<Route component={Login} />
		</Switch>
	);

	if (isAuthenticated) {
		routes = (
			<Switch>
				<Route path="/sites" render={props => <Sites {...props} />} />
				<Route path="/current-labor" render={props => <CurrentLabor {...props} />} />
				<Route path="/unit-availability" render={props => <UnitAvailability {...props} />} />
				<Route path="/csi-events" render={props => <CsiEvents {...props} />} />
				<Route path="/report-issue" render={props => <ReportIssue {...props} />} />
				<Route path="/logout" component={Logout} />
				<Redirect from="/" to="/sites" />
			</Switch>
		);
	}

	return (
		<Suspense fallback={<p>Loading...</p>}>{routes}</Suspense>
	)
};

export default Routes;